import { USER_LOGIN, USER_LOGOUT } from "../actions";
import { GAME_SET_DATA, GAME_RANDOMIZED_DATA, GAME_ADD_POINTS, GAME_REDUCE_POINTS, GAME_SET_BET, GAME_SET_BET_LOCK, GAME_SET_BET_UNLOCK, GAME_SET_FOCUS_LINK_INDEX, GAME_SHOULD_REWARD_POINTS, GAME_SET_STATUS, GAME_STATUS_WON, GAME_STATUS_LOST, GAME_SET_DATA_INDEX, GAME_SET_POINTS, GAME_SET_ALLOW_HINT_ON_FOCUS_LINK } from "../actions/game";

import quizQuestions from "../data/question.json";
import alternateWords from "../data/alternateWords.json";
import { setGameData, randomizedGameData, addGamePoints, reduceGamePoints, setGameBet, setGameBetLock, setGameBetUnlock, setGameFocusLinkIndex, setShouldRewardPoints, setGameStatus, setGameDataIndex, setGamePoints, setIsAllowHintOnFocusLink } from "./game";
import { loginUser, logoutUser } from "./user";
import { REWARD_VIDEO_READY, REWARD_VIDEO_IRONSOURCE, REWARD_VIDEO_OPEN, REWARD_VIDEO_COMPLETION, REWARD_VIDEO_AD_BLOCKED, REWARD_VIDEO_SUPPORT, REWARD_VIDEO_STALE } from "../package-ironsource/actions/rewardVideo";
import { rewardVideoReady, setIronRV, rewardVideoOpen, rewardVideoComplete, rewardVideoAdBlocked, setRewardVideoSupport, updateRewardVideoStale } from "../package-ironsource/reducers/rewardVideo";
import { AUDIO_SET_SOUNDS } from "../actions/audio";
import { setAudioSounds } from "./audio";

const initialState = {
  angle: 45,
  quizQuestions,
  alternateWords,
  userLoggedIn: false,
  game: {
    data: [],
    dataIndex: 0,
    points: 200,
    status: null,
    // status: GAME_STATUS_WON,
    // status: GAME_STATUS_LOST,
    bet: 0,
    betLocked: false,
    focusLinkIndex: null,
    isAllowHintOnFocusLink: false,
    shouldRewardPoints: false
  },
  rewardVideo: {
    adBlocked: false,
    // noCampaign: false,
    ready: null,
    open: false,
    // close: false,
    complete: false,
    ironRV: null,
    support: false,
    stale: true
  },
  audio: {
    sounds: []
  } 
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN:
      return loginUser(state, action);
    case USER_LOGOUT:
      return logoutUser(state, action);
    case GAME_SET_DATA:
      return setGameData(state, action);
    case GAME_SET_DATA_INDEX:
      return setGameDataIndex(state, action);
    case GAME_RANDOMIZED_DATA:
      return randomizedGameData(state, action);
    case GAME_ADD_POINTS:
      return addGamePoints(state, action);
    case GAME_SET_POINTS:
      return setGamePoints(state, action);
    case GAME_SET_BET:
      return setGameBet(state, action);
    case GAME_REDUCE_POINTS:
      return reduceGamePoints(state, action);
    case GAME_SET_BET_LOCK:
      return setGameBetLock(state, action);
    case GAME_SET_BET_UNLOCK:
      return setGameBetUnlock(state, action);
    case GAME_SET_FOCUS_LINK_INDEX:
      return setGameFocusLinkIndex(state, action);
    case GAME_SET_ALLOW_HINT_ON_FOCUS_LINK:
      return setIsAllowHintOnFocusLink(state, action);
    case GAME_SHOULD_REWARD_POINTS:
      return setShouldRewardPoints(state, action);
    case GAME_SET_STATUS:
      return setGameStatus(state, action);
    case REWARD_VIDEO_READY:
      return rewardVideoReady(state, action);
    case REWARD_VIDEO_IRONSOURCE:
      return setIronRV(state, action);
    case REWARD_VIDEO_OPEN:
      return rewardVideoOpen(state, action);
    case REWARD_VIDEO_COMPLETION:
      return rewardVideoComplete(state, action);
    case REWARD_VIDEO_AD_BLOCKED:
      return rewardVideoAdBlocked(state, action);
    case REWARD_VIDEO_SUPPORT:
      return setRewardVideoSupport(state, action);
    case REWARD_VIDEO_STALE:
      return updateRewardVideoStale(state, action);
    case AUDIO_SET_SOUNDS:
      return setAudioSounds(state, action);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js